// src/youknow/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics }   from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDDJ4WGsKRX-E7gAmRqv0rOnkKuXgKhVw4",
  authDomain: "youknow-ca70b.firebaseapp.com",
  projectId: "youknow-ca70b",
  storageBucket: "youknow-ca70b.firebasestorage.app",
  messagingSenderId: "424497532946",
  appId: "1:424497532946:web:ca49bb5dd2e931930188cb",
  measurementId: "G-VH7LDK722K"
};

// const app = initializeApp(firebaseConfig);

// export const auth = getAuth(app);
// export const provider = new GoogleAuthProvider();

// Initialize core Firebase services
const app       = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Set up Authentication
const auth     = getAuth(app);
const provider = new GoogleAuthProvider();

// Optional: force account selection on every login
provider.setCustomParameters({ prompt: 'select_account' });

export { auth, provider, signInWithPopup, analytics };